<div class="stellar-section">
  <!-- <div class="section-header">
    <h2>¿Donde Nos Encontramos?</h2>
    <div class="divider"></div>
</div> -->
  <div class="stellar-block inicio2">
    <div class="map-container">
      <!-- <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3075.1739566226547!2d2.6466477129711894!3d39.578229671468144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x129789b946be3801%3A0xe3ad2f5226b947b5!2sSegursub%20SL!5e0!3m2!1ses!2ses!4v1732756430586!5m2!1ses!2ses"
        width="100%"
        height="450"
        style="border: 0"
        allowfullscreen="true"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe> -->

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3063.4601959777524!2d3.1257456765037883!3d39.841518890447176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12962c8dfd4babeb%3A0x31fe7993fa7d2146!2sRestaurante%20Chino%20Don%20Chon!5e0!3m2!1ses!2ses!4v1744137224121!5m2!1ses!2ses"
        width="100%"
        height="450"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  </div>
</div>
